var _slicedToArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _require = require('crypto'),
    diffieHellman = _require.diffieHellman,
    KeyObject = _require.KeyObject,
    sign = _require.sign,
    verify = _require.verify;

var _process$version$subs = process.version.substr(1).split('.').map(function (x) {
  return parseInt(x, 10);
}),
    _process$version$subs2 = _slicedToArray(_process$version$subs, 2),
    major = _process$version$subs2[0],
    minor = _process$version$subs2[1];

module.exports = {
  oaepHashSupported: major > 12 || major === 12 && minor >= 9,
  keyObjectSupported: !!KeyObject && major >= 12,
  edDSASupported: !!sign && !!verify,
  dsaEncodingSupported: major > 13 || major === 13 && minor >= 2 || major === 12 && minor >= 16,
  improvedDH: !!diffieHellman
};